<template>
  <v-container class="pa-0">
    <v-row no-gutters>
      <v-col
        cols="3"
        :style="{
          backgroundColor: PAYMENT_CERTIFICATE_TABLE_COLOR.BLUE,
          justifyContent: 'center',
        }"
      >
        <div class="pa-2 border">
          <v-img
            alt="Vattenfall Logo"
            contain
            src="../../../assets/logo.svg"
            max-height="50px"
            max-width="150px"
          />
        </div>
      </v-col>
      <v-col
        class="border header-text"
        :style="{
          backgroundColor: PAYMENT_CERTIFICATE_TABLE_COLOR.BLUE,
          justifyContent: 'center',
        }"
      >
        <h2 class="pa-2">
          {{ $t("payment.certificate.interimPaymentCertificate") }}
        </h2>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col
        class="border header-text"
        cols="12"
        :style="{
          backgroundColor: PAYMENT_CERTIFICATE_TABLE_COLOR.WHITE,
          justifyContent: 'center',
        }"
      >
        <h2 class="pa-2">
          {{ $t('payment.certificate.project') }}
        </h2>
        <v-text-field
          v-model="localTitle"
          dense
          flat
          hide-details
          label="Enter Title"
          solo
          type="text"
        >
        </v-text-field>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { PAYMENT_CERTIFICATE_TABLE_COLOR } from '@/helpers'
import _ from 'lodash'

export default {
  props: {
    title: {
      type: String
    }
  },
  data () {
    return {
      PAYMENT_CERTIFICATE_TABLE_COLOR,
      localTitle: this.title
    }
  },
  watch: {
    title (newTitle) {
      this.localTitle = newTitle
    },
    localTitle (newValue) {
      this.debouncedInputChange(newValue)
    }
  },
  created () {
    this.debouncedInputChange = _.debounce(this.emitChange, 500)
  },
  methods: {
    emitChange (value) {
      this.$emit('editTitle', value)
    }
  }
}
</script>
